import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase';
import { isEqual } from 'lodash';

export const UserContext = createContext();

function UserContextProvider({ children }) {
  const [isLoading, setLoadingStatus] = useState(true);
  const [user, setUserProfile] = useState(null);

  useEffect(() => {
    // get user information and save it into state
    firebase.auth().onAuthStateChanged(async currentUser => {
      if (currentUser) {
        await firebase.database().ref(`users/${currentUser.uid}`).on('value', (snapshot) => {
          const data = snapshot.toJSON();
  
          if (currentUser && data && data.role === 'admin') {
              const userData = currentUser.toJSON();
              const { uid, email, createdAt } = userData;
              const { name, role, phone, profileImage } = data;
  
              const userObject = {
                name,
                userId: uid,
                phone,
                profileImage,
                createdAt,
                email,
                role,
              }
  
              if (!isEqual(user, userObject)) {
                setLoadingStatus(false);
                setUserProfile(userObject);
              }
          } else {
            setLoadingStatus(false);
            setUserProfile(null);
          }
        });
      } else {
        setLoadingStatus(false);
        setUserProfile(null);
      }
    });
  }, [isLoading, user]);

  return (
    <UserContext.Provider value={{ isLoading, user }}>
      {children}
    </UserContext.Provider>
  );
}

UserContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserContextProvider;
